import { render, staticRenderFns } from "./recharge.vue?vue&type=template&id=36b7d5c9&scoped=true"
import script from "./recharge.vue?vue&type=script&lang=js"
export * from "./recharge.vue?vue&type=script&lang=js"
import style0 from "./recharge.vue?vue&type=style&index=0&id=36b7d5c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b7d5c9",
  null
  
)

export default component.exports